import Mockman from "mockman-js";

export const MockMan = () => {
  return (
    <div>
      <Mockman />
    </div>
  );
};
